import { Alert, Button, Flex, Image, Spinner, Text } from "@chakra-ui/react";

import { CheckIcon, ECashIcon, ErrorIcon } from "../icons";
import UserAvatar from "../user/user-avatar";
import UserLink from "../user/user-link";

export default function NutzapPayStep({
  state,
  error,
  pubkey,
  onComplete,
  onRetry,
}: {
  state: "sending" | "sent" | "error";
  error?: string;
  pubkey: string;
  onComplete: () => void;
  onRetry: () => void;
}) {
  return (
    <Flex direction="column" gap="4" alignItems="center" py="4">
      <Flex gap="2" alignItems="center">
        <UserAvatar pubkey={pubkey} size="md" />
        <UserLink pubkey={pubkey} fontWeight="bold" />
      </Flex>

      {state === "sending" && (
        <Flex alignItems="center" gap="2">
          <Spinner size="sm" />
          <Text>Sending lit...</Text>
        </Flex>
      )}

      {state === "sent" && (
        <>
          <Image src="/filler/success.png" h="80px" objectFit="contain" />
          <Flex alignItems="center" gap="2" color="green.500">
            <CheckIcon boxSize={5} />
            <Text fontWeight="bold">Lit sent!</Text>
          </Flex>
          <Button onClick={onComplete} colorScheme="primary" size="sm">
            Done
          </Button>
        </>
      )}

      {state === "error" && (
        <>
          <Alert status="error" borderRadius="md">
            {error || "Failed to send lit"}
          </Alert>
          <Button onClick={onRetry} size="sm">
            Try Again
          </Button>
        </>
      )}
    </Flex>
  );
}
